import FormForgotPasswordReset from './FormForgotPasswordReset';

export default FormForgotPasswordReset;
